import React, { useState } from "react";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
  Box,
  useTheme,
  useMediaQuery,
  FormLabel
} from "@mui/material";
import { ReserveStatus } from '../../../../api/unit/ReserveStatus';

// ラジオボタンの定義
const radioItems = [
  {
    value: "1",
    contents: "バスケ",
  },
  {
    value: "2",
    contents: "バスケ＋飲み会",
  },
  {
    value: "3",
    contents: "飲み会",
  }
];

// 読み取り専用フラグ
let isReadOnly = false;

/**
 * 予約内容区分
 *
 * @param inputItem 入力値
 * @param inputRef 入力値の追跡オブジェクト
 * @param reserveType 予約の種類（1：バスケのみ開催、2：バスケ&飲み会開催、3：飲み会のみ開催）
 * @returns ラジオボタン
 */
export const ParticipateRadio = ({ inputItem, inputRef, reserveType, reserveStatus }: any) => {
  // 初期値をinputItemから取得
  const [localValue, setLocalValue] = useState<string>(inputItem || reserveType);
  const [checkedValue, setCheckedValue] = useState(localValue);

  // レスポンシブ対応
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // 入力済みかどうかを判定するフラグを更新する
  isReadOnly = !(inputItem === null || inputItem === '') || (reserveType !== "2");
  inputRef.current = localValue;
  // キャンセル承認待ちかつ入力が空の場合
  if (ReserveStatus.CancelApprovalWait === reserveStatus.status && (inputItem === null || inputItem === '')) {
    return (<>なし（キャンセル申請中）</>);
  }

  // 入力変更時に親コンポーネントに値を通知
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCheckedValue(e.target.value);
    const newValue = e.target.value;
    setLocalValue(newValue); // ローカルの状態を更新
    if (inputRef.current !== null) {
      inputRef.current = newValue; // useRefの値を更新
    }
  };

  // 読み取り専用の場合、選択済みの内容を表示
  if (isReadOnly) {
    return (
      <Typography variant="body1">
        予約内容：{radioItems.find((item) => item.value === checkedValue)?.contents}
      </Typography>
    );
  }

  // ラジオボタン入力フォームを表示
  else {
    return (
      <Box sx={{ width: '100%', padding: 2 }}>
        <FormControl component="fieldset" fullWidth>
          <FormLabel component="legend">予約内容</FormLabel>
          <RadioGroup
            value={localValue}
            onChange={handleChange}
            row={!isMobile} // モバイル画面では縦に並べ、PCでは横に並べる
          >
            {radioItems.map((item) => (
              <FormControlLabel
                key={item.value}
                value={item.value}
                control={<Radio />}
                label={item.contents}
                sx={{ marginBottom: isMobile ? 2 : 0 }} // モバイルで下に余白を追加
              />
            ))}
          </RadioGroup>
        </FormControl>
      </Box>
    );
  }
};
